// extracted by mini-css-extract-plugin
module.exports = {"navDotWrapper":"ul","navDot":"um","isRental":"un","navDotActive":"uo"};